/**
 * Fixed Header Spacing Adjuster
 * Dynamically adjusts the top margin/padding of the first content section
 * to prevent it from being hidden behind the fixed header
 * Only runs on the homepage
 */
(function() {
  'use strict';

  // Only run on homepage
  if (!document.body.classList.contains('template-index')) {
    return;
  }

  // Configuration
  const HEADER_SELECTOR = '.site-header';
  const MAIN_CONTENT_SELECTOR = '#MainContent';
  const FIRST_SECTION_SELECTOR = '#MainContent > section:first-of-type';
  
  /**
   * Get the actual height of the fixed header
   */
  function getHeaderHeight() {
    const header = document.querySelector(HEADER_SELECTOR);
    if (!header) return 0;
    
    // Use getBoundingClientRect for accurate height including borders/padding
    return header.getBoundingClientRect().height;
  }

  /**
   * Apply the calculated spacing to the first section
   */
  function adjustFirstSectionSpacing() {
    const firstSection = document.querySelector(FIRST_SECTION_SELECTOR);
    const mainContent = document.querySelector(MAIN_CONTENT_SELECTOR);
    
    if (!firstSection && !mainContent) {
      console.warn('Fixed Header Spacing: No first section or main content found');
      return;
    }

    const headerHeight = getHeaderHeight();
    
    // Apply to first section if it exists, otherwise to main content
    const targetElement = firstSection || mainContent;
    
    if (headerHeight > 0) {
      targetElement.style.marginTop = headerHeight + 'px';
      console.log('Fixed Header Spacing: Applied ' + headerHeight + 'px margin-top');
    }
  }

  /**
   * Initialize the spacing adjuster
   */
  function init() {
    // Run on initial load
    adjustFirstSectionSpacing();
    
    // Run again after a short delay to catch any late-loading header content
    setTimeout(adjustFirstSectionSpacing, 100);
    setTimeout(adjustFirstSectionSpacing, 500);
  }

  /**
   * Debounce function to limit resize event frequency
   */
  function debounce(func, wait) {
    let timeout;
    return function executedFunction() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        func.apply(context, args);
      }, wait);
    };
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Recalculate on window resize with debouncing (300ms delay)
  window.addEventListener('resize', debounce(adjustFirstSectionSpacing, 300));

  // Expose function globally in case manual recalculation is needed
  window.adjustHeaderSpacing = adjustFirstSectionSpacing;

})();
